import { Component, Input } from '@angular/core';

// Small presentational icon button for "copy this ID/phone/code" next to a
// displayed value — swaps to a checkmark for 1.5s on click so the user gets
// feedback without a toast interrupting a dense table. Falls back to the
// execCommand('copy') trick (same one registrationCode.component.ts already
// used) when navigator.clipboard isn't available, e.g. a non-HTTPS origin.
@Component({
  selector: 'app-copy-button',
  templateUrl: 'copy-button.component.html',
  styleUrls: ['copy-button.component.scss']
})
export class CopyButtonComponent {
  @Input() value: string;
  @Input() label = 'value';
  copied = false;

  copy(): void {
    if (this.value === null || this.value === undefined || this.value === '') {
      return;
    }
    const text = '' + this.value;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => this.flash());
      return;
    }
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(textArea);
    }
    this.flash();
  }

  private flash(): void {
    this.copied = true;
    setTimeout(() => { this.copied = false; }, 1500);
  }
}
